import { render, staticRenderFns } from "./refGOST2FTCard.vue?vue&type=template&id=568cd33d"
import script from "./refGOST2FTCard.vue?vue&type=script&lang=js"
export * from "./refGOST2FTCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports